import { setEventState } from "../../stateManagement/actions/eventActions";
import { eventType, reduxEventState } from "../../stateManagement/reducers/eventReducer";
import store from "../../stateManagement/store";
import { configurationAttributeType } from "../../types";
import { ChannelkartNetworkPost, ChannelkartNetworkPut } from "../networkService";
import { getNewConfiguration } from "../uiConfigService";

export type defaultParamsType = {
    [key: string]: Object;
}

export type mappingType={
    [key in eventType]:{
        name:string,
        params:{
            [key:string]:string
        }
    }
}

export async function logEvent(eventName:eventEnum, parameters:defaultParamsType) {
    try{
        let defaultParams:defaultParamsType = {
        "user_id": JSON.parse(localStorage.authContext).user.loginId,
        "action_time": new Date(),
        "source": "portal",
        "role_name":JSON.parse(localStorage.authContext).user.designation.toString()
        };

        let portalEventConfig = store.getState().eventConfigState;
        if(!portalEventConfig){
            let tempConfig = await getNewConfiguration("portal_event_config");
            let domainValues=tempConfig.domainValues;
            let tempObj: reduxEventState = {
                defaultParams: findObjectByName(domainValues, "defaultParams"),
                events: findObjectByName(domainValues, "events"),
            };
            setEventState(tempObj);
            portalEventConfig = tempObj;
        }
    
        if (portalEventConfig.events) {
        let events = portalEventConfig.events;
        let eventData = events[eventName];
        if (eventData !== null && eventData["status"] === "active") {
            let mappings = eventData["mappings"];
            logDatabaseEvent(mappings, parameters, defaultParams,portalEventConfig);
        }
        }
    }catch(e){
        return;
    }
}
  
const findObjectByName = (array:any, targetName:string) => {
    const foundObject = array.find((obj: configurationAttributeType<any>) => obj.name === targetName);
    return foundObject ? foundObject.value[0] : null;
};


function getDefaultParamsToSend(target:eventType, defaultParams:defaultParamsType,portalEventConfig:reduxEventState) {
    try{
        let defaultParamsToSend: defaultParamsType = {};
        let portalDefaultParams = portalEventConfig.defaultParams;
    
        if (portalDefaultParams) {
            let targetDefaultParams = portalDefaultParams[target];
        
            Object.entries(defaultParams).forEach(([key, value]) => {
                if (targetDefaultParams.hasOwnProperty(key) &&
                    targetDefaultParams[key]["status"] === "active") {
                defaultParamsToSend[targetDefaultParams[key]["name"]] = value;
                }
            });
        }
    
        return defaultParamsToSend;
    }catch(e){
        throw e;
    }
  }



async function logDatabaseEvent(mappings:mappingType, parameters:defaultParamsType, defaultParams:defaultParamsType,portalEventConfig:reduxEventState) {
    if (mappings.hasOwnProperty("database")) {
      let databaseMapping = mappings["database"];
      let databaseParams = databaseMapping["params"];
      let paramsToSend: defaultParamsType = {};
  
      Object.keys(databaseParams).forEach((key) => {
        const value = databaseParams[key]
        paramsToSend[value] = parameters[key];
      });
  
      let defaultParamsToSend = getDefaultParamsToSend("database", defaultParams,portalEventConfig);
  
      let body = {
        "actionType": databaseMapping["name"],
        "actionData": { ...defaultParamsToSend, ...paramsToSend }
      };
  
      try {
        ChannelkartNetworkPost("/v1/analytics",body);
      } catch (e) {
        throw e;
      }
    }
}

export enum eventEnum{
    login='login',
    logout='logout',
    admin_panel='admin_panel',
    salescode_studio='salescode_studio',
    integration_plugin='integration_plugin',
    impact_dashboard='impact_dashboard',
    live_dashboard='live_dashboard',
    ui_config_click='ui_config_click',
    manage_homescreen="manage_homescreen"

}

